import { useState } from 'react';
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogDescription,
} from '@/components/ui/dialog';
import { cn } from '@/lib/utils';

interface VoicePreviewProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  name: string;
  avatarUrl?: string;
  description: string;
}

export function VoicePreview({
  open,
  onOpenChange,
  name,
  avatarUrl,
  description,
}: VoicePreviewProps) {
  const [imageLoaded, setImageLoaded] = useState(false);

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-md">
        <DialogHeader>
          <DialogTitle>Meet {name}</DialogTitle>
          <DialogDescription>{description}</DialogDescription>
        </DialogHeader>
        {avatarUrl ? (
          <div className="relative aspect-square overflow-hidden rounded-lg">
            <div className={cn(
              "absolute inset-0 bg-neutral-100 animate-pulse",
              imageLoaded && "hidden"
            )} />
            <img
              src={avatarUrl}
              alt={name}
              className={cn(
                "w-full h-full object-cover transition-opacity duration-300",
                !imageLoaded && "opacity-0"
              )}
              onLoad={() => setImageLoaded(true)}
            />
          </div>
        ) : (
          <div className="flex aspect-square items-center justify-center rounded-lg bg-neutral-950 text-8xl font-semibold text-white">
            {name.charAt(0)}
          </div>
        )}
      </DialogContent>
    </Dialog>
  );
}
